import { css } from '@emotion/react/macro';

const cssStyles = {
  stringPreview: css({}),
};

export default cssStyles;
